import type { SVGAttributes } from 'react';

export function PortugueseIcon(props: SVGAttributes<SVGSVGElement>) {
	return (
		<svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
			<g clipPath="url(#clip0_328_488)">
				<path
					d="M0 15.9994C0 22.8788 4.34199 28.7435 10.4347 31.0041L11.826 15.9993L10.4347 0.994629C4.34199 3.25537 0 9.11999 0 15.9994Z"
					fill="#6DA544"
				/>
				<path
					d="M32 15.9995C32 7.163 24.8365 -0.000488281 16 -0.000488281C14.0429 -0.000488281 12.1681 0.351574 10.4347 0.994697V31.0043C12.1681 31.6475 14.0429 31.9995 16 31.9995C24.8365 31.9995 32 24.836 32 15.9995Z"
					fill="#D80027"
				/>
				<path
					d="M10.4348 21.5649C13.5084 21.5649 16 19.0733 16 15.9997C16 12.9262 13.5084 10.4346 10.4348 10.4346C7.36124 10.4346 4.86963 12.9262 4.86963 15.9997C4.86963 19.0733 7.36124 21.5649 10.4348 21.5649Z"
					fill="#FFDA44"
				/>
				<path
					d="M7.30432 13.2168V16.695C7.30432 18.4239 8.70582 19.8255 10.4348 19.8255C12.1637 19.8255 13.5652 18.424 13.5652 16.695V13.2168H7.30432Z"
					fill="#D80027"
				/>
				<path
					d="M10.4347 17.7385C9.85936 17.7385 9.39124 17.2703 9.39124 16.695V15.3037H11.4782V16.695C11.4782 17.2703 11.01 17.7385 10.4347 17.7385Z"
					fill="#F0F0F0"
				/>
			</g>
			<defs>
				<clipPath id="clip0_328_488">
					<rect width="31.9999" height="31.9999" fill="white" />
				</clipPath>
			</defs>
		</svg>
	);
}
